import { types } from 'mobx-state-tree';
import { Shape } from './shape-model';

export const ImageElement = Shape.named('ImageElement')
  .props({
    type: types.optional(types.string, 'image'),
    src: types.optional(types.string, ''),
    cropX: types.optional(types.number, 0),
    cropY: types.optional(types.number, 0),
    cropWidth: types.optional(types.number, 1),
    cropHeight: types.optional(types.number, 1),
    cornerRadius: types.optional(types.number, 0),
    flipX: types.optional(types.boolean, false),
    flipY: types.optional(types.boolean, false),
    clipSrc: types.optional(types.string, ''),
    borderColor: types.optional(types.string, ''),
    borderSize: types.optional(types.number, 0),
    keepRatio: types.optional(types.boolean, true),
    stretchEnabled: types.optional(types.boolean, false),
  })
  .preProcessSnapshot((snapshot) => {
    if (!snapshot) return snapshot;
    const s = { ...snapshot };
    const numericKeys = ['cropX', 'cropY', 'cropWidth', 'cropHeight', 'cornerRadius', 'borderSize'];
    numericKeys.forEach((key) => {
      if (key in s && typeof s[key] === 'string') {
        s[key] = parseFloat(s[key]) || 0;
      }
    });
    const boolKeys = ['flipX', 'flipY', 'keepRatio', 'stretchEnabled'];
    boolKeys.forEach((key) => {
      if (key in s && typeof s[key] === 'string') {
        s[key] = s[key] === 'true';
      }
    });
    return s;
  })
  .volatile(() => ({
    _cropModeEnabled: false,
  }))
  .actions((self) => ({
    toggleCropMode(flag) {
      self._cropModeEnabled = flag !== undefined ? flag : !self._cropModeEnabled;
    },
  }));
